export interface ImageErrorProps {
  error?: string;
}

export const ImageError = ({ error }: ImageErrorProps) => {
  if (!error) return <>{}</>;
  return <div className="image-error">{error}</div>;
};
